import dayjs from 'dayjs';
import {
  GRAPH_SELECTED_POINT_COLOR,
  GRAPH_VIOLATION_POINT_COLOR,
  IGraphCode,
  getTooltipSubtitle,
} from '../GraphService';
import { getRequest } from '../../../Services/HttpService';
import { AxiosResponse } from 'axios';

export interface IEcoDriveXYData {
  x: string;
  y: number | null;
}

export interface IEcoDriveDataset {
  data: IEcoDriveXYData[];
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
  pointBackgroundColor: string | string[];
  pointBorderColor: string;
  pointRadius?: number | (number | null)[];
  pointHoverRadius?: number | (number | null)[];
  cubicInterpolationMode: string;
}

export const getEcoDriveSummaryData = async (vehicleId: number, rideId?: string) => {
  if (vehicleId) {
    const url = `/v1/vehicle/${vehicleId}/graph/ecoScore/summary${
      rideId ? `?rideId=${rideId}` : ''
    }`;
    const response: AxiosResponse | false = await getRequest(url);
    if (response && response.data && response.status === 200) {
      return response.data;
    }
    return false;
  }
  return false;
};

export const renderEcoDriveTooltip = (tooltipModel, ref, tooltips, f, isCompressed) => {
  let graphCode: IGraphCode | null = null;
  // Tooltip Element
  let tooltipEl = document.getElementById('chartjs-tooltip');

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip';
    tooltipEl.innerHTML = `<div><div id="point"></div><table></table></div>`;
    document.body.appendChild(tooltipEl);
    tooltipEl.style.zIndex = '999';
  }
  let isViolation = false;

  // Hide if no tooltip
  if (String(tooltipModel.opacity) === '0') {
    tooltipEl.style.opacity = '0';
    return null;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  const getBody = (bodyItem) => {
    return bodyItem.lines;
  };

  // Set Text
  if (tooltipModel.body) {
    const titleLines = tooltipModel.title || [];
    const bodyLines = tooltipModel.body.map(getBody);

    let innerHtml = '<thead>';
    let xLabel = '';
    let yLabel = '';
    // let distance = '';
    let address = '';
    let lineIndex = '';

    titleLines.forEach((title: string) => {
      innerHtml += `<tr><th> </th><th> </th></tr>`;
      xLabel = dayjs(title).format('DD.MM.YYYY HH:mm:ss');
      lineIndex = title;
    });
    innerHtml += '</thead><tbody>';

    bodyLines.forEach((body: string, i: number) => {
      yLabel = Number(body).toFixed(1);
    });

    innerHtml += `<tr><td>${f({
      id: `tripsOverview.title.ecoScore`,
    })}${
      isCompressed ? getTooltipSubtitle(tooltipModel?.dataPoints, f) : ''
    }:&nbsp;</td><td><strong>${yLabel}</strong></td></tr>`;
    innerHtml += `<tr><td>${f({
      id: `onlinepanel.date`,
    })}:&nbsp;</td><td><strong>${xLabel}</strong></td></tr>`;

    if (tooltips && tooltips[lineIndex]) {
      address = tooltips[lineIndex].address
        ? `<tr><td>${f({
            id: `infoWindow.adress`,
          })}&nbsp;</td><td><strong>${tooltips[lineIndex].address}</strong></td></tr>`
        : '';
      graphCode = {
        code: tooltips[lineIndex].code,
        address: tooltips[lineIndex].address,
        timestamp: lineIndex,
      };

      innerHtml += address;

      isViolation = tooltips[lineIndex].violations && tooltips[lineIndex].violations.length > 0;
      if (tooltips[lineIndex].violations) {
        tooltips[lineIndex].violations.forEach((i, key) => {
          if (i.type !== tooltips[lineIndex].violations[key - 1]) {
            innerHtml += `<tr><td>${f({
              id: `tripsOverview.section.violation.tooltip`,
            })}:&nbsp;</td><td><strong>${
              i.type
                ? f({
                    id: `tripsOverview.section.${i.type}.tooltip`,
                  })
                : '-'
            }</strong></td></tr>`;
            innerHtml += i.duration
              ? `<tr><td>${f({
                  id: `tripsOverview.section.duration.tooltip`,
                })}:&nbsp;</td><td><strong>${i.duration}</strong></td></tr>`
              : '';
            innerHtml += i.maxValue
              ? `<tr><td>${f({
                  id: `tripsOverview.section.maxValue.tooltip`,
                })}:&nbsp;</td><td><strong>${i.maxValue}</strong></td></tr>`
              : '';
          }
        });
      }
      // distance = tooltips[line.index].distance
      //   ? `<tr><td>${f({
      //       id: `tripsOverview.section.distance.tooltip`,
      //     })}:&nbsp;</td><td><strong>${tooltips[line.index].distance}</strong></td></tr>`
      //   : '';
    }

    // innerHtml += distance;

    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');
    if (tableRoot) {
      tableRoot.innerHTML = innerHtml;
    }
  }

  // `this` will be the overall tooltip
  const position = ref._chart.canvas.getBoundingClientRect();
  const point: any = document.getElementById('point');

  // Display, position, and set styles for font
  const shift = window.innerWidth - tooltipModel.caretX < 500 ? 214 : 0;
  if (point) {
    if (isViolation) {
      point.style = '';
    } else {
      point.style =
        window.innerWidth - tooltipModel.caretX < 500
          ? 'width: 13px; height: 13px; position: absolute; background: #389ded; top: -8px; right: -15px; border: 4px solid #fff; border-radius: 50%;'
          : 'width: 13px; height: 13px; position: absolute; background: #389ded; top: -8px; left: -15px; border: 4px solid #fff; border-radius: 50%;';
    }
  }
  tooltipEl.style.opacity = '1';
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.left = `${
    7 + position.left + window.pageXOffset + tooltipModel.caretX - shift
  }px`;
  tooltipEl.style.top = `${position.top + window.pageYOffset + tooltipModel.caretY}px`;
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
  tooltipEl.style.fontSize = `${tooltipModel.bodyFontSize}px`;
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
  tooltipEl.style.padding = `${tooltipModel.yPadding}px ${tooltipModel.xPadding}px`;
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.background = '#494949';
  tooltipEl.style.color = '#fff';
  tooltipEl.style.border = '1px solid #ccc';
  tooltipEl.style.borderRadius = '3px';
  tooltipEl.style.width = '200px';
  return graphCode;
};

export const getClickedPointAndViolations = (
  datasetsData: IEcoDriveXYData[],
  timestamp: string,
  tooltips: Record<string, any>
) => {
  return datasetsData.map((item) => {
    if (
      item.x === timestamp ||
      (tooltips[item.x] && tooltips[item.x].violations && tooltips[item.x].violations.length > 0)
    ) {
      return 6;
    }
    return 0;
  });
};

export const getClickedPointColorAndViolations = (
  datasetsData: IEcoDriveXYData[],
  timestamp: string,
  tooltips: Record<string, any>
) => {
  return datasetsData.map((item) => {
    if (item.x === timestamp) {
      return GRAPH_SELECTED_POINT_COLOR;
    }
    if (tooltips[item.x] && tooltips[item.x].violations && tooltips[item.x].violations.length > 0) {
      return GRAPH_VIOLATION_POINT_COLOR;
    }
    return '';
  });
};
